import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import React from "react";

export default function ForgetPassword({ onClose, isOpen, product }) {
  const cancelRef = React.useRef();
  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader>Lupa Password ?</AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody py="5">
          Jika lupa password mohon untuk menghubungi call center pajak BPKAD
          Karangasem 082145229090
        </AlertDialogBody>
      </AlertDialogContent>
    </AlertDialog>
  );
}
